import React, { useContext, useEffect, useState } from 'react';
import {
  Trash2,
  Heart,
  Minus,
  Plus,
  ShoppingBag,
  Tag,
  ArrowLeft
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../../../assests/css/customer/ShoppingCartPage.css';
import Footer from '../../../components/Customer/Footer/Footer';
import MyNavbar from '../../../components/Customer/Mynavbar/MyNavbar';
import axios from "axios";
import AppContext from '../../../context/AppContext';
import Swal from "sweetalert2";

const ShoppingCartPage = () => {
  const navigate = useNavigate();
  const { baseUrl, setCartCount, wishlistCount, setWishlistCount, requireLogin } =
    useContext(AppContext);

  const [loading, setLoading] = useState(true);
  const [cartItems, setCartItems] = useState([]);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [couponCode, setCouponCode] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const shippingCost = 250;
  const freeShippingThreshold = 15000;

  const customer = JSON.parse(localStorage.getItem("loggedInCustomer"));
  const MlcustomerId = customer?.id;

  const subtotal = cartItems.reduce(
    (sum, item) => sum + (item.price * item.quantity),
    0
  );
  const discount = appliedCoupon
    ? (subtotal * appliedCoupon.discount / 100)
    : 0;
  const shipping =
    subtotal >= freeShippingThreshold
      ? 0
      : shippingCost;

  const total = subtotal - discount + shipping;
  const totalItems = cartItems.reduce(
    (sum, item) => sum + item.quantity,
    0
  );
  const shippingProgress = Math.min(
    (subtotal / freeShippingThreshold) * 100,
    100
  );
  const amountToFreeShipping = Math.max(
    freeShippingThreshold - subtotal,
    0
  );

  const viewcart = () => {
    if (!MlcustomerId) {
      setCartItems([]);
      setCartCount(0);
      setLoading(false);
      return;
    }

    setLoading(true);
    axios.get(`${baseUrl}/customer/cart/viewCart/${MlcustomerId}`)
      .then((response) => {
        setCartItems(response.data.carts);
        setCartCount(response.data.carts.length);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const getWishlist = () => {
    if (!MlcustomerId) {
      setWishlistItems([]);
      setWishlistCount(0);
      return;
    }

    axios.get(`${baseUrl}/customer/wishlists/GetAllwishlist/${MlcustomerId}`)
      .then((response) => {
        setWishlistItems(response.data.wishlists);
        setWishlistCount(response.data.wishlists.length);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewcart();
    getWishlist();
  }, []);

  const deleteCart = (id) => {
    if (!requireLogin()) return;

    const formData = new FormData();
    formData.append("cart_id", id);
    axios.post(`${baseUrl}/customer/cart/deleteCart`, formData)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Item removed from cart"
        });
        viewcart();
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      });
  };

  const updateCart = (id, qty) => {
    if (qty < 1) return;
    if (!requireLogin()) return;

    const formData = new FormData();
    formData.append("cart_id", id);
    formData.append("quantity", qty);
    axios.post(`${baseUrl}/customer/cart/updateCart`, formData)
      .then(() => {
        viewcart();
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      });
  };

  const isInWishlist = (productId) => {
    return wishlistItems.some(
      (item) => item.mlproduct_id === productId
    );
  };

  const toggleWishlist = (item) => {
    if (!requireLogin()) return;

    const existingItem = wishlistItems.find(
      (wishlistItem) => wishlistItem.mlproduct_id === item.Mlproduct_id
    );

    if (existingItem) {
      axios.delete(`${baseUrl}/customer/wishlists/deleteWishlist`, {
        data: { wishlist_id: existingItem.id }
      })
        .then(() => {
          const updatedWishlist = wishlistItems.filter(
            (w) => w.id !== existingItem.id
          );
          setWishlistItems(updatedWishlist);
          setWishlistCount(updatedWishlist.length);
          Swal.fire({
            icon: "success",
            title: "Removed",
            text: "Removed from wishlist",
            timer: 1000,
            showConfirmButton: false
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      const formData = new FormData();
      formData.append("mlcustomer_id", MlcustomerId);
      formData.append("mlproduct_id", item.Mlproduct_id);

      axios.post(`${baseUrl}/customer/wishlists/addtowishlist`, formData)
        .then((response) => {
          const updatedWishlist = [...wishlistItems, response.data.wishlist];
          setWishlistItems(updatedWishlist);
          setWishlistCount(updatedWishlist.length);
          Swal.fire({
            icon: "success",
            title: "Added",
            text: "Added to wishlist",
            timer: 1000,
            showConfirmButton: false
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const applyCoupon = () => {
    if (couponCode === "SAVE10") {
      setAppliedCoupon({
        code: "SAVE10",
        discount: 10
      });
    } else {
      alert("Invalid Coupon");
    }
  };

  return (
    <>
      <MyNavbar />

      <br />
      <br />

      <div className="shopping-cart-page">
        <div className="cart-header">

          <div className="cart-title-section">

            <ShoppingBag size={32} className="cart-icon-header" />

            <h1 className="cart-title">Shopping Cart</h1>

            <span className="cart-count">
              {totalItems} {totalItems === 1 ? 'item' : 'items'}
            </span>

          </div>

          <a href="/" className="continue-shopping-link">
            <ArrowLeft size={18} />
            <span>Continue Shopping</span>
          </a>

        </div>

        {loading ? (

          <div style={{ textAlign: 'center', padding: '80px 0' }}>
            <div
              style={{
                width: '50px',
                height: '50px',
                border: '5px solid #f3e8d8',
                borderTop: '5px solid #E3CAA5',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto'
              }}
            ></div>
            <p style={{ marginTop: '15px', color: '#888', fontSize: '16px' }}>
              Loading your cart...
            </p>
          </div>

        ) : !MlcustomerId ? (

          <div className="empty-cart">
            <h2>Please Login</h2>
            <p>Login to view and manage your cart</p>
            <button
              className="continue-shopping-btn"
              onClick={() => navigate("/login")}
            >
              <ShoppingBag size={20} />
              <span>Login</span>
            </button>
          </div>

        ) : cartItems.length === 0 ? (

          <div className="empty-cart">
            <h2>Your Cart is Empty</h2>
            <p>Looks like you haven't added anything yet!</p>
            <a href="/" className="continue-shopping-btn">
              <ShoppingBag size={20} />
              <span>Start Shopping</span>
            </a>
          </div>

        ) : (

          <>
            <div className="cart-items-container">

              {cartItems.map((item) => (

                <div key={item.id} className="cart-item">
                  <div className="cart-item-image">
                    <img
                      src={item.image_path}
                      alt={item.title}
                      loading="lazy"
                      onError={(e) => {
                        e.target.src =
                          'https://via.placeholder.com/150x200?text=No+Image';
                      }}
                    />
                  </div>

                  <div className="cart-item-details">
                    <h3 className="item-name">{item.title}</h3>
                    <div className="item-price">
                      <span className="price-value">
                        Rs.{item.price?.toLocaleString()}
                      </span>
                    </div>
                  </div>

                  <div className="cart-item-quantity">
                    <div className="quantity-selector">
                      <button
                        disabled={item.quantity <= 1}
                        onClick={() => updateCart(item.id, item.quantity - 1)}
                      >
                        <Minus size={16} />
                      </button>

                      <span className="quantity-value">{item.quantity}</span>

                      <button
                        onClick={() => updateCart(item.id, item.quantity + 1)}
                      >
                        <Plus size={16} />
                      </button>
                    </div>
                  </div>

                  <div className="cart-item-subtotal">
                    <span className="subtotal-value">
                      Rs.{(item.price * item.quantity).toLocaleString()}
                    </span>
                  </div>

                  <div className="cart-item-actions">
                    <button
                      className="move-wishlist-btn"
                      onClick={() => toggleWishlist(item)}
                    >
                      <Heart
                        size={20}
                        color={isInWishlist(item.Mlproduct_id) ? "red" : "#555"}
                        fill={isInWishlist(item.Mlproduct_id) ? "red" : "none"}
                      />
                    </button>
                    <button
                      className="remove-btn"
                      onClick={() => deleteCart(item.id)}
                    >
                      <Trash2 size={20} />
                    </button>
                  </div>

                </div>

              ))}

            </div>

            <div className="cart-summary">

              <h3>Order Summary</h3>

              <div className="coupon-section">
                <div className="coupon-input-group">
                  <Tag size={20} />
                  <input
                    type="text"
                    placeholder="Enter coupon code"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                  />
                  <button disabled={!couponCode.trim()} onClick={applyCoupon}>
                    Apply
                  </button>
                </div>
              </div>

              <div className="summary-details">
                <div className="summary-row">
                  <span>Subtotal:</span>
                  <span>Rs. {subtotal.toLocaleString()}</span>
                </div>

                {appliedCoupon && (
                  <div className="summary-row">
                    <span>Discount:</span>
                    <span>- Rs. {discount.toLocaleString()}</span>
                  </div>
                )}

                <div className="summary-row">
                  <span>Shipping:</span>
                  <span>
                    {shipping === 0 ? 'FREE' : `Rs. ${shipping.toLocaleString()}`}
                  </span>
                </div>

                <div className="summary-row total-row">
                  <span>Total:</span>
                  <span>Rs. {total.toLocaleString()}</span>
                </div>
              </div>

              <button
                className="checkout-btn"
                onClick={() => {
                  if (!requireLogin()) return;

                  navigate("/checkout", {
                    state: {
                      cartItems,
                      subtotal,
                      discount,
                      shipping,
                      total,
                      appliedCoupon
                    }
                  });
                }}
              >
                Proceed to Checkout
              </button>

            </div>

          </>
        )}

      </div>

      <Footer />
    </>
  );
};

export default ShoppingCartPage;